 <template>
    <div class="skelton_loading">
        <div class="skline graph"></div>
        <div class="graph_legends">
        <div class="skline"></div>
        <div class="skline"></div>
        <div class="skline"></div>
        </div>
    </div>
</template>

<script>

    export default {
        name:"chartLoading",
        components: {
            
        },
        data: () => ({
            
        }),
       
        mounted() {
         
    
        },
        methods: {
                 
            
        },
        computed: {
           
        }
    };

</script>